import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { springfieldOrConfig } from "./data";

export default function SpringfieldOrPage() {
  return <OregonCityPageTemplate config={springfieldOrConfig} />;
}